import * as THREE from 'three';
import IMOG from '~/lib/imog';
import '~/lib/three/useBvh';

import Renderer from '~/imog/Renderer';
// import Gizmo from '~/imog/Gizmo';
import Scene from '~/imog/Scene';

export default IMOG.Component('Canvas', {
  options: {
    handleReady: () => {},
    handleItemLoaded: () => {},
  },

  props() {
    return {
      loading: true,
    };
  },

  setup({ options }) {
    this.renderer = new Renderer();

    // this.gizmo = new Gizmo({
    //   options: {
    //     addTo: this.renderer.worldScene,
    //   },
    // });

    this.scene = new Scene({
      options: {
        addTo: this.renderer.worldScene,
      },
      props: {},
    });

    THREE.DefaultLoadingManager.onLoad = () => {
      options.handleReady();
      this.$trigger('mainLoad');
      this.props.loading = false;
    };

    THREE.DefaultLoadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
      options.handleItemLoaded({ itemsLoaded, itemsTotal });
    };

    THREE.DefaultLoadingManager.onError = function (url) {
      console.log('There was an error loading ' + url);
    };
    THREE.DefaultLoadingManager.itemStart('dummy');
    THREE.DefaultLoadingManager.itemEnd('dummy');
  },

  render() {
    this.renderer.render();
  },
});
